import { render, staticRenderFns } from "./newSummary.vue?vue&type=template&id=06efe3a4"
import script from "./newSummary.vue?vue&type=script&lang=js"
export * from "./newSummary.vue?vue&type=script&lang=js"
import style0 from "./newSummary.vue?vue&type=style&index=0&id=06efe3a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports